import Model from './Model'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc).extend(relativeTime)

export default class Notice extends Model {
  resource() {
    return 'notices'
  }

  get createdAtFromNow() {
    return dayjs.utc(this.created_at).fromNow()
  }
}
